// 塞尔维亚语
import srLocale from 'element-ui/lib/locale/lang/sr'


const sr = {
  // ============== 登陆页 start=============
  "登录": "Prijava",
"退出": "Odjava",
"账号": "Nalog",
"密码": "Lozinka",
"验证码": "Verifikacioni kod",
"请输入账号": "Molimo unesite svoj nalog",
"请输入密码": "Molimo unesite lozinku",
"请输入验证码": "Molimo unesite verifikacioni kod",
"验证码不正确": "Netačan verifikacioni kod",
"没有账号": "Nema naloga",
"请": "Molimo",
"点击注册": "Kliknite za registraciju",
  // ============== 登陆页 end  =============
  // =========== 首页 start==================
  "门店总量": "Ukupan broj prodavnica",
"用户总量": "Ukupan broj korisnika",
"营业总量": "Ukupan poslovni promet",
"订单总量": "Ukupan obim naloga",
"商品总量": "Ukupan inventar",
"销售总额": "Ukupna prodaja",
"元": "€",
"预计收入": "Procenjeni prihod",
"今日概况": "Današnji pregled",
"销售额": "Obim prodaje",
"支付订单数": "Plaćeni nalozi",
"昨日": "Juče",
"新增用户数": "Novi korisnici",
"新增商户": "Novi trgovci",
"下单用户数": "Korisnici koji daju naloge",
"待办事项": "Nedovršeni zadaci",
"请尽快处理，以免影响营业": "Molimo vas da odmah rešite kako biste izbegli uticaj na poslovanje",
"待处理订单": "Nalozi na čekanju",
"库存告急": "Hitno upozorenje o zalihama",
"销量": "Obim prodaje",
"暂无上榜记录": "Trenutno nema zapisa o rangiranju",
"成交额": "Vrednost transakcija",
"成交量": "Broj transakcija",
"退单额": "Ukupan iznos povraćaja",
"退单量": "Povratni zahtevi",
  // =========== 首页 end==================
  // =========== 建店必做 start=============
  "基本资料": "Osnovne informacije",
"编辑门店": "Uredi prodavnicu",
"官方网站": "Zvanična veb lokacija",
"门店服务": "Usluge prodavnice",
"服务与营业时间": "Usluge i radno vreme",
"收银台": "Kasa",
"后厨": "Kuhinja",
"商品": "Roba",
"添加商品": "Dodaj robu",
"网站": "Veb lokacija",
"网站编辑": "Uređivanje veb lokacije",
"上一步": "Prethodni korak",
"保存": "Sačuvaj",
"下一步": "Sledeći korak",
"提交失败": "Neuspela dostava",
"获取当前进度信息失败": "Neuspelo dobijanje trenutnih informacija o napretku",
"请输入门店名称": "Molimo unesite naziv prodavnice",
"登录密码": "Lozinka za prijavljivanje",
"请输入登录密码": "Molimo unesite lozinku za prijavljivanje",
"确认密码": "Potvrdite lozinku",
"请输入确认密码": "Molimo unesite potvrdu lozinke",
"联系人": "Kontakt",
"请输入联系人": "Molimo unesite ime kontakta",
"请输入联系电话": "Molimo unesite kontaktni broj telefona",
"店铺类型": "Tip prodavnice",
"分店": "Ogranak",
"直营": "Direktne prodaje",
"商品分类": "Klasifikacija robe",
"同步主店": "Sinhronizujte sa glavnom prodavnicom",
"分店创建": "Kreiranje ogranaka",
"温馨提示：选择后，请勿随意修改，以免造成门店商品数据错乱": "Topao podsjetnik: Nakon odabira, molimo ne menjajte nasumično da biste izbegli konfuziju podataka o proizvodima prodavnice",
"绑定用户": "Veži korisnika",
"选择用户": "Odaberite korisnika",
"用户昵称": "Nadimak",
"门店logo": "Logo prodavnice",
"选择图片": "Odaberite sliku",
"地址": "Adresa",
"请输入地址": "Unesite adresu",
"门店坐标": "Koordinate prodavnice",
"商家介绍": "Predstavljanje prodavca",
"状态": "Status",
"开启": "Otvoreno",
"禁止": "Zatvoreno",
"营业状态": "Radno stanje",
"营业中": "Otvoreno",
"停止营业": "Zatvoreno",
"上传图片": "Postavi sliku",
"获取当前门店失败，请刷新界面重试": "Neuspešno dobijanje trenutne prodavnice, osvežite stranicu i pokušajte ponovo",
"商城名称": "Ime tržnog centra",
"商城名称不能为空": "Ime tržnog centra ne sme biti prazno",
"访问网址后缀": "Sufiks za pristup URL-u",
"访问网址": "Posetite URL",
"手机网站": "Mobilni sajt",
"默认": "Podrazumevano",
"自定义": "Prilagođeno",
"Pad点餐网站": "Pad sajt za naručivanje",
"收银台网站": "Sajt za kasu",
"后厨网站": "Sajt za kuhinju",
"会员设置": "Postavke članova",
"请选择默认头像": "Molimo odaberite podrazumevani avatar",
"门店二维码": "QR kod prodavnice",
"下载": "Preuzimanje",
"营业时间": "Radno vreme",
"店内营业时间": "Radno vreme u prodavnici",
"请选择店内营业时间": "Molimo odaberite radno vreme u prodavnici",
"开始时间": "Početno vreme",
"结束时间": "Krajnje vreme",
"选择时间范围": "Odaberite vremenski opseg",
"自提营业时间": "Radno vreme za samoposluživanje",
"请选择自提营业时间": "Molimo odaberite radno vreme za samoposluživanje",
"外卖营业时间": "Radno vreme dostave hrane",
"请选择外卖营业时间": "Molimo odaberite radno vreme dostave hrane",
"外卖配送": "Dostava hrane",
"注": "Napomena",
"外卖配送方式至少选择一个": "Morate odabrati barem jedan način dostave hrane",
"店内配置": "Postavke u prodavnici",
"店内用餐方式至少选择一个": "Morate odabrati barem jedan način konzumiranja hrane u prodavnici",
"堂食服务": "Usluga konzumiranja hrane u restoranu",
"店内堂食结算模式": "Način plaćanja u restoranu",
"先结账后用餐": "Plati prvo, pa jedi",
"先用餐后结账": "Jedi prvo, pa plati",
"收银台桌台清台设置": "Postavke čišćenja stolova na kasi",
"定时清台": "Čišćenje stolova",
"立即清台": "Odmah čišćenje stolova",
"开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效": "Nakon uključivanja zakazanog čišćenja stolova, sistem će automatski očistiti sto za naplatu nakon podešenog vremena. Ova funkcija radi samo u režimu plaćanja pre obroka",
"桌台订单清台设置": "Postavke čišćenja stolova s narudžbama",
"分钟后自动清理桌台（扫桌码点餐和收银桌台点餐定时清台时间）": "Automatsko čišćenje stolova nakon minuta (vreme za čišćenje stolova za naručivanje skeniranjem stolova i vreme za čišćenje stolova naplate)",
"店内堂食服务费": "Naknada za uslugu konzumiranja hrane u restoranu",
"按就餐人数收取": "Naplaćuje se po broju gostiju",
"按每桌收取": "Naplaćuje se po stolu",
"请输入服务费": "Molimo unesite naknadu za uslugu",
"位": "Mesto",
"桌": "Sto",
"店内包装费类型": "Vrsta takse za pakovanje u prodavnici",
"按商品收费": "Naplatiti prema proizvodu",
"按单收费": "Naplatiti po narudžbi",
"包装费": "Taksa za pakovanje",
"请输入包装费": "Molimo unesite taksu za pakovanje",
"外卖服务": "Usluga dostave hrane",
"外卖包装费类型": "Vrsta takse za pakovanje prilikom dostave",
"外卖配送范围": "Opseg dostave hrane",
"请输入外卖配送范围": "Molimo unesite opseg dostave hrane",
"外卖配送费": "Naknada za dostavu hrane",
  "请输入外卖配送费": "Unesite naknadu za dostavu hrane",
"最低消费": "Minimalna potrošnja",
"请输入最低消费": "Molimo unesite minimalnu potrošnju",
"桌码管理": "Upravljanje kodom stola",
"添加类型": "Dodaj tip",
"类型名称": "Ime tipa",
"删除": "Izbriši",
"桌位管理": "Upravljanje stolovima",
"最少人数": "Minimalan broj ljudi",
"最多人数": "Maksimalan broj ljudi",
"取 消": "Otkaži",
"确 定": "Potvrdi",
"请输入类型名称": "Molimo unesite ime tipa",
"排序不能为空": "Sortiranje ne sme biti prazno",
"排序必须为数字": "Sortiranje mora biti broj",
"添加成功": "Uspešno dodato",
"修改类型": "Izmeni tip",
"修改成功": "Uspešno izmenjeno",
"添加区域": "Dodaj oblast",
"区域名称": "Ime oblasti",
"修改区域": "Izmeni oblast",
"请输入区域名称": "Molimo unesite ime oblasti",
"分类名称": "Ime kategorije",
"编号": "Broj",
"选择区域": "Izaberi oblast",
"请选择": "Molimo izaberite",
"选择类型": "Izaberi tip",
"桌号id": "ID stola",
"所属区域": "Pripadajuća oblast",
"桌位类型": "Tip stola",
"桌位编码": "Kod stola",
"人数区间": "Opseg broja ljudi",
"人": "Ljudi",
"二维码": "QR kod",
"桌位编号": "Broj stola",
"请输入桌位编号": "Molimo unesite broj stola",
"请选择类型名称": "Molimo izaberite ime tipa",
"请选择所属区域": "Molimo izaberite pripadajuću oblast",
"添加桌位": "Dodaj sto",
"关键词": "Ključna reč",
"添加收银员": "Dodaj blagajnika",
"姓名": "Ime",
"登录账号": "Korisničko ime za prijavu",
"联系方式": "Kontaktni način",
"收银员管理": "Upravljanje blagajnicima",
"编辑": "Uredi",
"手机号": "Broj mobilnog telefona",
"请输入登录账号": "Molimo unesite korisničko ime za prijavu",
"长度在6到16个字符": "Dužina između 6 i 16 karaktera",
"两次输入密码不一致！": "Unesene lozinke se ne poklapaju!",
"禁用": "Onemogući",
"删除后不可恢复，确认删除该记录吗?": "Nakon brisanja nije moguće vraćanje, potvrdite brisanje zapisa?",
"提示": "Savet",
"后厨人员管理": "Upravljanje osobljem u kuhinji",
"添加后厨人员": "Dodaj osoblje u kuhinji",
"添加后厨账号": "Dodaj kuhinjski nalog",
"普通分类": "Obična klasifikacija",
"添加分类": "Dodaj kategoriju",
"图片": "Slika",
"分类排序": "Sortiranje kategorija",
"税率设置": "Postavljanje poreske stope",
"添加税率": "Dodaj poresku stopu",
"税率分类名称": "Ime kategorije poreske stope",
"税率": "Poreska stopa",
"适用于菜品分类": "Primenjivo na klasifikaciju jela",
"未找到相应数据": "Podaci nisu pronađeni",
"请输入分类名称": "Molimo unesite ime kategorije",
"分类排序不能为空": "Sortiranje kategorija ne sme biti prazno",
"分类排序必须为数字": "Sortiranje kategorija mora biti broj",
"正在翻译，请稍后": "Prevođenje, molimo sačekajte",
"多语言翻译": "Prevod na više jezika",
"修改分类": "Izmeni kategoriju",
"翻译": "Prevod",
"分类图片": "Slika kategorije",
"外卖商品": "Proizvodi za dostavu",
"店内商品": "Proizvodi u prodavnici",
"商品管理": "Upravljanje proizvodima",
"分类管理": "Upravljanje kategorijama",
"上架中": "Na prodaju",
"下架": "Van prodaje",
"商品名称": "Ime proizvoda",
"请输入商品名称": "Molimo unesite ime proizvoda",
"添加产品": "Dodaj proizvod",
"产品": "Proizvod",
"实际销量": "Stvarna prodaja",
"库存": "Inventar",
"发布时间": "Vreme objavljivanja",
"销售价": "Prodajna cena",
"下架中": "Van prodaje",
"强制下架": "Obavezno skloni s police",
"重新上架": "Ponovo staviti na policu",
"上架": "Stavi na policu",
"确认要": "Potvrdi da",
"成功": "Uspeh",
"删除成功": "Uspešno obrisano",
"请先选择一个选项": "Molimo prvo izaberite opciju",
"正在完成翻译，请稍后操作": "Završavam prevod, molimo sačekajte sa operacijom",
"请检查表单的必填项是否全部填写": "Molimo proverite da li su sva obavezna polja forme popunjena",
"补全成功": "Uspešno dopunjeno",
"主语言选择": "Izbor glavnog jezika",
"请选择主语言": "Molimo izaberite glavni jezik",
"高级设置": "Napredne postavke",
"取消": "Otkaži",
"修改": "Izmeni",
"保存成功": "Uspešno sačuvano",
"规格": "Specifikacija",
"库存计算方式": "Metoda računanja inventara",
"下单减库存": "Smanjenje inventara pri naručivanju",
"特色分类": "Posebna klasifikacija",
"产品规格": "Specifikacija proizvoda",
"单规格": "Jedna specifikacija",
"多规格": "Više specifikacija",
"此商品正在参加活动，不能修改规格": "Ovaj proizvod učestvuje u akciji, ne može se menjati specifikacija",
"AI魔法创建": "AI Magično Kreiranje",
"通过人工智能技术，可以根据商品名称自动填写商品详细信息，如配料、卖点、口味等。": "Pomoću veštačke inteligencije, možete automatski popuniti detaljne informacije o proizvodu na osnovu njegovog imena, kao što su sastojci, prodajni argumenti, ukus itd.",
"所属分类": "Pripadajuća kategorija",
"请选择商品分类": "Molimo izaberite kategoriju proizvoda",
"请填写商品详情": "Molimo popunite detalje proizvoda",
"商品详情": "Detalji proizvoda",
"换一换": "Zameni",
"产品价格": "Cena proizvoda",
"请填写产品价格": "Molimo unesite cenu proizvoda",
"请填写包装费": "Molimo unesite taksu za pakovanje",
"规格明细": "Detalji specifikacije",
"规格名称": "Ime specifikacije",
"请输入内容": "Molimo unesite sadržaj",
"价格": "Cena",
"添加规格": "Dodaj specifikaciju",
"商品图片": "Slika proizvoda",
"请上传商品图片": "Molimo dodajte sliku proizvoda",
"从AI图库中选择": "Izaberite iz AI biblioteke slika",
"使用中文从AI图库搜索": "Pretražujte AI biblioteku slika koristeći kineski jezik",
"AI图库": "AI Biblioteka slika",
"确认使用": "Potvrdi korišćenje",
"AI未识别到您的商品图片": "AI nije prepoznao sliku vašeg proizvoda",
"可在搜索框": "Moguće je u pretraživačkom okviru",
"更换菜品名称": "Promenite ime jela",
"请输入菜品名称！": "Molimo unesite ime jela!",
"请在主语言界面上进行操作": "Molimo izvršite operaciju na glavnom jezičkom interfejsu",
"本商品正在参加活动，不能删除规格！": "Ovaj proizvod učestvuje u akciji, ne može se obrisati specifikacija!",
"不能再删除了": "Nemoguće dalje brisanje",
"多语言": "Višejezičnost",
"商品加料": "Dodaci za proizvode",
"添加加料": "Dodaj dodatak",
"加料名称": "Ime dodatka",
"如:杯型": "Na primer: Vrsta čaše",
"内容": "Sadržaj",
"积分设置": "Postavke poena",
"是否开启积分赠送": "Da li otvoriti davanje poena",
"其他设置": "Druge postavke",
"商品状态": "Status proizvoda",
"选择商品状态": "Izaberite Status Proizvoda",
"初始销量": "Početna Prodaja",
"商品排序": "Sortiranje Proizvoda",
"限购数量": "Ograničenje Količine Kupovine",
"每个会员购买的最大数量，0为不限购": "Maksimalni broj koji svaki član može kupiti, 0 znači bez ograničenja",
"会员折扣设置": "Postavke Popusta za Članove",
"是否开启会员折扣": "Da li otvoriti Popust za Članove",
"默认折扣": "Podrazumevani Popust",
"单独设置折扣": "Podešavanje Popusta Posebno",
"默认折扣：默认为用户所属会员等级的折扣率": "Podrazumevani Popust: Podrazumevano je stopa popusta nivoa članstva kojem korisnik pripada",
"折扣佣金类型": "Vrsta Popusta Provizije",
"百分比": "Procenat",
"固定金额": "Fiksni Iznos",
"折扣": "Popust",
"请输入折扣": "Molimo unesite Popust",
"分销设置": "Podešavanje Distribucije",
"是否开启分销": "Da li otvoriti Distribuciju",
"分销规则": "Pravila Distribucije",
"平台规则": "Pravila Platforme",
"单独规则": "Posebna Pravila",
"平台规则：层级": "Pravila Platforme: Nivo",
"1级佣金": "Provizija Nivoa 1",
"2级佣金": "Provizija Nivoa 2",
"3级佣金": "Provizija Nivoa 3",
"分销佣金类型": "Vrsta Provizije za Distribuciju",
"单独分销设置": "Posebno Podešavanje Distribucije",
"一级佣金": "Provizija Nivoa 1",
"二级佣金": "Provizija Nivoa 2",
"三级佣金": "Provizija Nivoa 3",
"请填写商品名称": "Molimo unesite Naziv Proizvoda",
"你选择商品分类": "Izabrali ste Kategoriju Proizvoda",
"商品卖点": "Prodajna Tačka Proizvoda",
"配料": "Sastojci",
"添加项": "Dodaj Stavku",
"删除项": "Obriši Stavku",
"审核状态": "Status Pregleda",
"选择审核状态": "Izaberite Status Pregleda",
"通过": "Odobreno",
"未通过": "Nije Odobreno",
"审核备注": "Beleška Pregleda",
"请输入拒绝原因": "Molimo unesite Razlog Odbijanja",
"商品属性": "Atributi Proizvoda",
"添加属性": "Dodaj Atribute",
"属性名称": "Ime Atributa",
"属性值": "Vrednost Atributa",
"至少填写两个": "Najmanje Popunite Dva",
"如:温度": "Na primer: Temperatura",
"口味": "Ukus",
"商品同步": "Sinhronizacija Proizvoda",
"同步至外卖": "Sinhronizujte za Dostavu",
"库存数量": "Količina Inventara",
"请填写库存数量": "Molimo unesite Količinu Inventara",
"请上传分类图片": "Molimo postavite sliku Kategorije",
"发布": "Objavi",
"级": "Nivo",
"请填写口味": "Molimo unesite Ukus",
"从AI图库搜索": "Pretraži iz AI Biblioteke Slika",
"AI获取标签": "AI Dobija Oznake",
"标签": "Oznaka",
"添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求": "Dodane oznake mogu pomoći AI pomoćniku za naručivanje da preciznije razume potrebe mušterija",
"同步至店内": "Sinhronizujte za Unutrašnju Upotrebu",
"是否同步商品至外卖": "Da li Sinhronizovati Proizvode za Dostavu",
"是否同步商品至店内": "Da li Sinhronizovati Proizvode za Unutrašnju Upotrebu",
"付款减库存": "Plaćanje za Smanjenje Inventara",
"菜品录入使用语言": "Jezik za Unos Jela",
"网站主页": "Početna Stranica Sajta",
"主题编辑": "Uređivanje Teme",
"我的菜单": "Moj Meni",
"添加菜单": "Dodaj Meni",
"菜单名称": "Ime Menija",
"图标": "Ikona",
"是否显示": "Prikazati",
"添加时间": "Vreme Dodavanja",
"更新时间": "Vreme Ažuriranja",
"操作": "Radnja",
"正在处理": "Obrada",
"处理失败，请重试": "Neuspešna Obrada, Molimo Pokušajte Ponovo",
"此操作将永久删除该记录, 是否继续?": "Ova operacija će trajno obrisati ovaj zapis, da li želite nastaviti?",
"确定": "Potvrdi",
"主题选择": "Izbor Teme",
"主题一": "Tema Jedan",
"主题二": "Tema Dva",
"主题三": "Tema Tri",
"主题四": "Tema Četiri",
"主题五": "Tema Pet",
"主题六": "Tema Šest",
"主页预览": "Pregled Početne Stranice",
"撤回": "Povuci",
"获取预览网站失败,请检查网络或联系管理员": "Neuspešno Dobijanje Pregleda Sajta, Molimo Proverite Mrežu ili Kontaktirajte Administratora",
"撤回成功": "Povlačenje Uspešno",
"编辑菜单": "Uredi Meni",
"请输入广告标题": "Molimo Unesite Naslov Oglasa",
"图标大小为": "Veličina Ikonice je",
"显示": "Prikaz",
"隐藏": "Sakrij",
"请输入数字": "Molimo Unesite Broj",
"链接": "Link",
"选择链接": "Izaberite Link",
"提交": "Potvrdi",
  "请输入菜单名称": "Molimo unesite Ime Menija",
"链接到": "Link do",
"请上传图标": "Molimo postavite Ikonicu",
"确定要删除吗?": "Da li ste sigurni da želite da obrišete?",
"次浏览": "Pregleda",
"每日必拼": "Dnevni Moraš Se Boriti",
"更多": "Više",
"2人团": "2-Osoba Grupa",
"去开团": "Idi Otvaraj Grupu",
"活动砍价": "Aktivnost Kupovina na Sekundu",
"已抢2件": "Već Uzeto 2 Komada",
"立即砍价": "Kupovina na Sekundu Odmah",
"满": "Puni",
"可用": "Dostupan",
"立即领取": "Odmah Preuzmi",
"热门直播": "Popularni Uživo",
"已售": "Prodato",
"限时秒杀": "Ograničeno Vreme Sekundarno Ubistvo",
"搜索商品": "Pretraži Proizvode",
"线下门店": "Prodavnica na Terenu",
"门店地址": "Adresa Prodavnice",
"联系电话": "Kontakt Telefon",
"您的浏览器不支持 video 标签": "Vaš Pretraživač ne podržava Oznake Video Zapisa",
"店家正在直播、折扣套餐秒杀中": "Vlasnik Prodavnice Uživo Emituje, Sekundarno Ubijanje Odmaha Paket Sa Popustom",
"进入": "Ulaz",
"至少保留一个": "Zadrži Barem Jedan",
"咨询分类": "Kategorija Konsultacija",
"全部分类": "Sve Kategorije",
"显示数量": "Prikaži Količinu",
"咨询数据请到": "Podaci o Konsultacijama Idite na",
"插件": "Dodatak",
"资讯": "Informacije",
"显示类型": "Tip Prikaza",
"有图模式": "Sa Modulom Slike",
"无图模式": "Bez Modula Slike",
"组件样式": "Stil Komponente",
"显示内容": "Pokaži Sadržaj",
"拼团价格": "Cena Grupnog Borenja",
"划线价格": "Ocenjena Cena",
"指示点颜色": "Boja Pokazivača Tačke",
"重置": "Resetuj",
"切换时间": "Promeni Vreme",
"轮播图自动切换的间隔时间，单位：毫秒": "Interval Vreme za Automatsku Promenu Slike Karausela, Jedinica: Milisekundi",
"链接地址": "Adresa Linka",
"请选择链接地址": "Molimo Izaberite Adresu Linka",
"添加一个": "Dodaj Jedan",
"标题内容": "Sadržaj Naslova",
"文字内容": "Tekstualni Sadržaj",
"链接名称": "Ime Linka",
"正在砍价": "Pregovara",
"商品原价": "Originalna Cena Proizvoda",
"背景颜色": "Boja Pozadine",
"组件高度": "Visina Komponente",
"上下边距": "Marger Gore i Dole",
"线条样式": "Stil Linije",
"实线": "Puna Linija",
"虚线": "Isprekidana Linija",
"点状": "Tačkasta",
"线条颜色": "Boja Linije",
"线条高度": "Visina Linije",
"左右边距": "Margin Levo i Desno",
"标题": "Naslov",
"颜色": "Boja",
"每行数量": "Broj Po Redu",
"1个": "1 Komad",
"2个": "2 Komada",
"文字颜色": "Boja Teksta",
"公告图标": "Ikona Obaveštenja",
"公告内容": "Sadržaj Obaveštenja",
"商品来源": "Izvor Proizvoda",
"自动获取": "Automatsko Dobavljanje",
"手动选择": "Ručni Odabir",
"综合": "Sveobuhvatno",
"商品列表": "Lista Proizvoda",
"选择产品": "Izaberite Proizvod",
"列表平铺": "Ravno Prikazivanje Liste",
"横向滑动": "Horizontalno Klizanje",
"分列数量": "Broj Kolona",
"单列": "Jedna Kolona",
"两列": "Dve Kolone",
"三列": "Tri Kolone",
"商品价格": "Cena Proizvoda",
"商品销量": "Prodaja Proizvoda",
"提示文字": "Tekst Upozorenja",
"搜索框样式": "Stil Pretraživača",
"方形": "Kvadratni",
"圆角": "Zaobljeni Uglovi",
"圆弧": "Luk",
"文字对齐": "Poravnanje Teksta",
"居左": "Levo",
"居中": "Centar",
"居右": "Desno",
"秒杀价格": "Cena Sekundarnog Ubistva",
"底边距": "Donji Margin",
"右边距": "Desni Margin",
"不透明度": "Neprozirnost",
"客服类型": "Tip Klijentske Podrške",
"在线聊天": "Online Ćaskanje",
"拨打电话": "Pozovi",
  "电话号码": "Broj Telefona",
"客服图标": "Ikona Korisničke Podrške",
"标题类型": "Vrsta Naslova",
"页面名称": "Ime Stranice",
"页面名称仅用于后台查找": "Ime Stranice Se Koristi Samo za Pretragu na Površini",
"分享标题": "Naslov Deljenja",
"小程序端转发时显示的标题": "Naslov Prikazan Prilikom Deljenja Mini Programa",
"文章数据请到": "Podaci o Članku Molimo Idite na",
"内容管理": "Upravljanje Sadržajem",
"文章列表": "Lista Članaka",
"中管理": "Upravljanje u",
"单行": "Jedan Red",
"两行": "Dva Reda",
"门店列表": "Lista Prodavnica",
"选择门店": "Izaberite Prodavnicu",
"展示数量": "Prikaži Količinu",
"视频高度": "Visina Video Zapisa",
"滑块可用左右方向键精确调整": "Potisnik Se Može Precizno Podesiti Levim i Desnim Strelicama",
"视频封面": "Video Omot",
"视频地址": "Adresa Video Klipa",
"自动播放": "Automatsko Reprodukovanje",
"布局方式": "Način Izlaganja",
"堆积两列": "Složi Dve Kolone",
"堆积三列": "Složi Tri Kolone",
"堆积四列": "Složi Četiri Kolone",
"橱窗样式": "Stil Izloga",
"橱窗样式最多显示四张图片，超出隐藏": "Stil Izloga Prikazuje Do Četiri Slike, Sakriva Se Ako Prekorači",
"请确保所有图片的尺寸/比例相同": "Molimo Proverite Da Su Sve Slike Istih Dimenzija/Odnosa",
"标题文字": "Tekst Naslova",
"组件库": "Biblioteka Komponenti",
"媒体组件": "Medijska Komponenta",
"商城组件": "Komponenta Tržnog Centra",
"工具组件": "Alatna Komponenta",
"登录组件": "Komponenta Prijava",
"资讯管理": "Upravljanje Informacijama",
"添加资讯": "Dodaj Informaciju",
"资讯ID": "ID Informacije",
"封面": "Naslovna Strana",
"资讯标题": "Naslov Informacije",
"虚拟阅读量": "Virtuelni Broj Čitanja",
"实际阅读量": "Stvarni Broj Čitanja",
"资讯排序": "Sortiranje Informacija",
"已取消删除": "Otkazano Brisanje",
"请输入文章标题": "Molimo Unesite Naslov Članka",
"描述": "Opis",
"请输入文章描述": "Molimo Unesite Opis Članka",
"缩略图": "Isječak",
"资讯分类": "Kategorija Informacija",
"资讯状态": "Status Informacija",
"资讯内容": "Sadržaj Informacija",
"分类ID": "ID Kategorije",
"编辑分类": "Uredi Kategoriju",
"恭喜你，修改成功": "Čestitamo, Uspješna Modifikacija",
"编辑资讯": "Uredi Informaciju",
"份": "Porcija",
"中文": "Kineski",
"英语": "Engleski",
"意大利语": "Italijanski",
"德语": "Njemački",
"西班牙语": "Španski",
"法语": "Francuski",
"克罗地亚": "Hrvatski",
"斯洛文尼亚": "Slovenački",
"匈牙利语": "Mađarski",
"规格库": "Biblioteka Specifikacija",
"属性库": "Biblioteka Atributa",
"加料库": "Biblioteka Dodataka",
"规格名": "Naziv Specifikacije",
"批量删除": "Masovno Brisanje",
"请输入规格名称": "Molimo Unesite Naziv Specifikacije",
"删除后不可恢复，确认删除吗?": "Nakon Brisanja, Ne Može Se Vratiti, Da Li Ste Sigurni Da Želite Da Obrišete?",
"属性名": "Naziv Atributa",
"请输入属性名称": "Molimo Unesite Naziv Atributa",
"请输入属性值": "Molimo Unesite Vrednost Atributa",
"添加属性名": "Dodaj Naziv Atributa",
  // =========== 建店必做 end ==================

  // ================ 订单 start ================
 "实时概况": "Pregled u realnom vremenu",
"营业总额": "Ukupni prihod od poslovanja",
"有效订单": "Validni narudžbine",
"退款金额": "Iznos povrata",
"销量排行榜": "Rangiranje prodaje",
"销售额排行榜": "Rangiranje iznosa prodaje",
"商品排行榜": "Rangiranje proizvoda",
"订单号": "Broj narudžbine",
"请输入订单号": "Molimo unesite broj narudžbine",
"起始时间": "Vreme početka",
"至": "Do",
"开始日期": "Datum početka",
"结束日期": "Datum završetka",
"查询": "Upit",
"导出": "Izvoz",
"全部订单": "Sve narudžbine",
"未付款": "Neplaćeno",
"进行中": "U toku",
"已完成": "Završeno",
"订单信息": "Informacije o narudžbini",
"下单时间": "Vreme narudžbine",
"取消申请中": "Otkazivanje u toku",
"实付款": "Stvarna uplata",
"含服务费": "Uključujući servisnu naknadu",
"含包装费": "Uključujući naknadu za pakovanje",
"买家": "Kupac",
"门店名称": "Naziv prodavnice",
"出餐状态": "Status obroka",
"准备中": "Priprema",
"出餐中": "Kuvanje",
"待取餐": "Čekanje za preuzimanje",
"交易状态": "Status transakcije",
"支付方式": "Način plaćanja",
"配送方式": "Način dostave",
"订单详情": "Detalji narudžbine",
"出餐": "Posluži obrok",
"退款": "Povrat novca",
"核销": "Verifikacija",
"确定要出餐吗?": "Da li ste sigurni da želite poslužiti obrok?",
"确定要核销吗?": "Da li ste sigurni da želite verifikaciju?",
"恭喜你，操作成功": "Čestitamo, uspešna operacija",
"已取消核销": "Verifikacija je otkazana",
"基本信息": "Osnovne informacije",
"订单来源": "Izvor narudžbine",
"订单金额": "Iznos narudžbine",
"配送费": "Troškovi dostave",
"服务费": "Naknada za uslugu",
"优惠券抵扣": "Popust na kuponu",
"积分抵扣": "Odbijanje poena",
"满减金额": "Iznos popusta",
"优惠金额": "Iznos popusta",
"实付款金额": "Stvarni iznos uplate",
"用餐方式": "Način konzumiranja hrane",
"取餐时间": "Vreme preuzimanja",
"桌号": "Broj stola",
"修改价格": "Izmeni cenu",
"门店信息": "Informacije o prodavnici",
"商品信息": "Informacije o proizvodu",
"会员折扣价": "Cena sa popustom za članstvo",
"购买数量": "Količina kupovine",
"商品总价": "Ukupna cena proizvoda",
"收货信息": "Podaci o isporuci",
"收货人": "Primalac",
"收货电话": "Telefon primaoca",
"收货地址": "Adresa za dostavu",
"备注": "Napomena",
"自提用户信息": "Informacije o korisniku samopreuzimanja",
"用户信息": "Informacije o korisniku",
"联系手机": "Kontaktni mobilni telefon",
"付款信息": "Informacije o plaćanju",
"应付款金额": "Iznos koji treba platiti",
"支付流水号": "Broj transakcije plaćanja",
"付款状态": "Status plaćanja",
"付款时间": "Vreme plaćanja",
"发货信息": "Informacije o isporuci",
"发货状态": "Status isporuke",
"取消信息": "Informacije o otkazivanju",
"商家备注": "Napomena prodavca",
"门店自提核销": "Verifikacija samopreuzimanja u prodavnici",
"核销员": "Osoba za verifikaciju",
"核销状态": "Status verifikacije",
"已核销": "Verifikovano",
"核销时间": "Vreme verifikacije",
"返回上一页": "Povratak na prethodnu stranicu",
"确认发货": "Potvrdi isporuku",
"确认审核": "Potvrdi pregled",
"请选择物流公司": "Molimo izaberite logističku kompaniju",
"请填写物流单号": "Molimo unesite broj logističkog broja",
"恭喜你，发货成功": "Čestitamo, uspešna isporuka",
"恭喜你，审核成功": "Čestitamo, uspešna provera",
"订单价格修改": "Izmena cene narudžbine",
"运费金额": "Iznos troškova dostave",
"最终付款价": "Konačna cena plaćanja",
"取消订单": "Otkaži narudžbinu",
"请输入备注": "Molimo unesite napomenu",
"请输入退款金额": "Molimo unesite iznos povrata",
"确认退款?": "Potvrdi povrat novca?",
"已取消退款": "Povrat novca je otkazan",
"含配送费": "Uključujući troškove dostave",
"确认送达": "Potvrdi isporuku",
"是否确认此操作?": "Da li potvrđujete ovu operaciju?",
"配送状态": "Status dostave",
"备注信息": "Informacije o napomeni",
"期望配送时间": "Očekivano vreme isporuke",
"订单状态": "Status narudžbine",
"骑手姓名": "Ime vozača",
"骑手电话": "Telefon vozača",
"操作时间": "Vreme operacije",
"详情": "Detalji",
"此操作将确认送达, 是否继续?": "Ova operacija će potvrditi isporuku, želite li nastaviti?",
"配送时间": "Vreme dostave",
"配送信息": "Informacije o dostavi",
"配送类型": "Tip isporuke",
"配送距离": "Razdaljina isporuke",
"配送电话": "Telefon za dostavu",
"配送费用": "Troškovi isporuke",
"送达时间": "Vreme dolaska",
"取消原因": "Razlog otkazivanja",
"请输入取消原因": "Molimo unesite razlog otkazivanja",
"米": "Metar",
  // ================ 订单 end  ================

  // ================= 门店 start ==============
 "门店ID": "ID Prodavnice",
"联系地址": "Kontaktna Adresa",
"下载二维码": "Preuzmite QR Kod",
"H5网页": "H5 Veb Stranica",
"添加门店": "Inkorporirajte Objekat",
"设置": "Konfiguracija",
"恭喜你，门店删除成功": "Čestitamo, Uspešno Brisanje Prodavnice",
"请输入地点": "Molimo Unesite Lokaciju",
"添加": "Inkorporirajte",
"等级": "Rang",
"请选择会员等级": "Molimo Izaberite Nivo Članstva",
"性别": "Pol",
"请选择性别": "Molimo Izaberite Pol",
"微信昵称": "WeChat Nadimak",
"请输入微信昵称": "Molimo Unesite WeChat Nadimak",
"微信头像": "WeChat Profilna Slika",
"昵称": "Nadimak",
"用户余额": "Stanje Korisnika",
"累积消费金额": "Nakupljena Potrošnja",
"注册时间": "Vreme Registracije",
"分钟后自动清理桌台": "Automatsko Čišćenje Stolova Nakon Minuta",
"扫桌码点餐和收银桌台点餐定时清台时间": "Planirano Vreme Čišćenja Stolova za Skeniranje Kodova Stolova za Naručivanje i Stolova za Naplatu",
"到店自提": "Preuzimanje u Prodavnici",
"打包带走": "Poneti Sumeštaj",
"店内就餐": "Konzumacija U Lokalu",
"外卖配送至少选择一种！": "Izaberite Bar Jedan Način Dostave za Poneti!",
"店内配置至少选择一种！": "Izaberite Bar Jednu Konfiguraciju u Lokalu!",
"恭喜你，设置成功": "Čestitamo, Uspešna Konfiguracija",
"恭喜你，门店修改成功": "Čestitamo, Uspešna Modifikacija Prodavnice",
"门店": "Prodavnica",
"提现金额": "Iznos Podizanja",
"打款方式": "Način Plaćanja",
"待审核": "Na Čekanju Pregleda",
"审核通过": "Odobreno",
"驳回": "Odbijeno",
"原因": "Razlog",
"已打款": "Plaćanje Izvršeno",
"审核": "Pregled",
"确认打款": "Potvrdi Plaćanje",
"确认要打款吗?": "Potvrditi Plaćanje?",
"供应商名称": "Ime Dobavljača",
"余额变动场景": "Scenario Promene Stanja",
"收入": "Prihod",
"提现": "Podizanje",
"起始日期": "Početni Datum",
"变动金额": "Iznos Promene",
"描述/说明": "Opis/Objašnjenje",
"创建时间": "Vreme Kreiranja",
"恭喜你，门店添加成功": "Čestitamo, Uspešno Dodavanje Prodavnice",
"驳回原因": "Razlog Odbijanja",
"提现审核": "Pregled Podizanja",
"小票打印设置": "Podešavanje Štampanja Računa",
"是否开启商户小票打印": "Omogućite Štampanje Računa za Trgovca",
"选择打印机": "Izaberite Štampač",
"是否开启顾客小票打印": "Omogućite Štampanje Računa za Klijente",
"选择打印机二": "Izaberite Drugi Štampač",
"是否开启厨房小票打印": "Omogućite Štampanje Računa za Kuhinju",
"选择打印机三": "Izaberite Treći Štampač",
"恭喜你，打印设置成功": "Čestitamo, Uspešno Podešavanje Štampanja",
"小票打印机列表": "Lista Štampača Računa",
"打印机ID": "ID Štampača",
"打印机名称": "Naziv Štampača",
"编辑小票打印机": "Uredite Štampač Računa",
"打印机类型": "Tip Štampača",
"米泰打印机": "Mettai Štampač",
"打印机编号": "Broj Serijskog Broja Štampača",
"打印机编号为9位数字，查看米泰打印机底部贴纸上面的编号": "Broj Serijskog Broja Štampača Sastoji Se od 9 Cifara, Proverite Broj Na Etiketi Iznad Podnožja Mettai Štampača",
"打印机秘钥": "Šifra Štampača",
"打印联数": "Broj Štampanja",
"同一订单，打印的次数": "Broj Štampanja Za Istu Narudžbinu",
"排序": "Poređaj",
"数字越小越靠前": "Manji Broj Znači Veći Prioritet",
"新增小票打印机": "Dodajte Novi Štampač Računa",
"恭喜你，添加成功": "Čestitamo, Uspešno Dodavanje",
"配送方式设置": "Podešavanje Načina Dostave",
"商家配送": "Dostava Trgovca",
"自动配送时间(分钟)": "Automatsko Vreme Dostave (minuta)",
"设置0不自动配送，下单后未配送，设置时间后自动操作配送": "Postavljanje Na 0 Znači Bez Automatske Dostave. Nakon Naručivanja Bez Dostave, Automatska Dostava će Biti Pokrenuta Nakon Postavljenog Vremena",
"商户编号": "ID Trgovca",
"门店编号": "ID Prodavnice",
"环境": "Okruženje",
"测试环境": "Testno Okruženje",
"正式环境": "Radno Okruženje",
"回调地址": "Adresa Povratnog Poziva",
"运营城市": "Operativni Grad",
"恭喜你，上传设置成功": "Čestitamo, Uspešno Podešavanje Unosa",
"菜品打印列表": "Lista Štampanja Hrane",
"名称": "Ime",
"打印类型": "Tip Štampanja",
"外卖": "Poneti",
"店内": "Unutar Restorana",
"菜品打印": "Štampanje Hrane",
"是否开启": "Omogućeno",
"配送打印": "Štampanje Dostave",
"店内打印": "Štampanje Unutar Restorana",
"打印方式": "Metod Štampanja",
"付款打印": "Štampanje Plaćanja",
"下单打印": "Štampanje Narudžbine",
"商品分组": "Grupisanje Proizvoda",
  "男": "Muško",
"女": "Žensko",
"未知": "Nepoznato",
"文件管理": "Upravljanje Datotekama",
"移动至": "Premesti u",
"点击上传": "Kliknite za Upload",
"删除失败": "Brisanje Neuspešno",
"请选择文件": "Molimo Izaberite Datoteku",
"确定移动选中的文件吗？, 是否继续?": "Da li ste sigurni da želite premestiti izabrane datoteke? Da li želite nastaviti?",
"只能上传图片！": "Moguće je samo upload-ovati slike!",
"上传文件只能是图片格式!": "Upload-ovana datoteka mora biti u formatu slike!",
"上传文件大小不能超过 2MB!": "Veličina upload-ovane datoteke ne sme preći 2MB!",
"请查看/裁切其它上传图片!": "Molimo pogledajte/isečite ostale upload-ovane slike!",
"图片上传中,请等待": "Upload-ovanje slike u toku, molimo sačekajte",
"当前图片上传失败!": "Trenutno upload-ovanje slike neuspešno!",
"本次上传图片失败": "Upload-ovanje slike ovog puta neuspešno",
"本次最多只能上传1个文件": "Samo 1 datoteka može biti upload-ovana odjednom",
"裁剪图片": "Iseci Sliku",
"选择优惠券": "Izaberite Kupon",
"数量": "Količina",
"无限制": "Neograničeno",
"请输入等级名称": "Molimo Unesite Naziv Rangova",
"长度在3到5个字符": "Dužina treba biti između 3 i 5 karaktera",
"错了哦，这是一条错误消息": "Ups, ovo je poruka o grešci",
"增加税率": "Dodaj Poreznu Stopu",
"税率分类": "Kategorija Poreznih Stopa",
"请输入税率分类": "Molimo Unesite Kategoriju Poreznih Stopa",
"自定义税率分类": "Prilagođena Kategorija Poreznih Stopa",
"请输入税率值": "Molimo Unesite Vrednost Porezne Stope",
"单位是": "Jedinica je",
"适用菜品分类": "Primenljiva Kategorija Hrane",
"请选择菜品分类": "Molimo Izaberite Kategoriju Hrane",
"修改税率信息": "Izmeni Informacije o Poreznoj Stopi",
"分类名称不能为空": "Naziv Kategorije ne sme biti prazan",
  // ================= 门店 end ==============
  // =====================  营销工具start ==========
  "会员管理": "Upravljanje Članstvom",
"等级管理": "Upravljanje Nivoima",
"余额明细": "Detalji Stanja",
"请输入昵称": "Molimo unesite nadimak",
"邮箱": "Email",
"请输入邮箱地址": "Molimo unesite email adresu",
"会员等级": "Nivo Članstva",
"全部": "Sve",
"无等级": "Bez Nivoa",
"余额": "Stanje",
"积分": "Bodovi",
"生日": "Rođendan",
"充值": "Napuni",
"恭喜你，用户删除成功": "Čestitamo, korisnik uspešno obrisan",
"请选择等级": "Molimo izaberite nivo",
"管理员备注": "Napomene Administratora",
"请输入管理员备注": "Molimo unesite napomene administratora",
"恭喜你，用户修改成功": "Čestitamo, korisnik uspešno izmenjen",
"会员充值": "Napuni Članstvo",
"充值余额": "Iznos Napunjenog Stanja",
"当前余额": "Trenutno Stanje",
"充值方式": "Metod Napunjavanja",
"增加": "Povećaj",
"减少": "Smanji",
"最终金额": "Konačan Iznos",
"变更金额": "Promenjen Iznos",
"请输入变更金额": "Molimo unesite promenjen iznos",
"添加等级": "Dodaj Nivo",
"等级名称": "Naziv Nivoa",
"权重": "Težina",
"升级条件": "Uslovi za Napredovanje",
"等级权重": "Težina Nivoa",
"请输入等级权重": "Molimo unesite težinu nivoa",
"权重越大，等级越高": "Što je veća težina, to je viši nivo",
"等级折扣": "Popust na Nivou",
"请输入等级折扣": "Molimo unesite popust na nivou",
"满足以下勾选的其中一个条件，会员自动升级到该等级": "Ako se ispuni bilo koji od dolazećih uslova, član će biti automatski unapređen na taj nivo",
"累计消费满": "Kumulativna potrošnja dostiže",
"编辑等级": "Uredi Nivo",
"累计积分满": "Kumulativni bodovi dostižu",
"推荐人数满": "Preporučeni broj dostiže",
"恭喜你，等级修改成功": "Čestitamo, nivo uspešno izmenjen",
"个": "komada",
"充值设置": "Podešavanja Napunjavanja",
"是否开启余额充值": "Omogući napunjavanje stanja",
"注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启": "Napomena: Ako je omogućeno, dugme za napunjavanje će biti prikazano na mobilnom uređaju; ako mini program ne prođe proveru kvalifikacija, može ostati isključeno",
"是否开启自定义金额": "Omogući prilagođeni iznos",
"注：如开启则用户可以填写充值金额": "Napomena: Ako je omogućeno, korisnici mogu uneti prilagođeni iznos napunjavanja",
"最低充值金额": "Minimalni iznos napunjavanja",
"注：自定义充值金额最低充值多少€": "Napomena: Koja je minimalna suma napunjavanja za prilagođene iznose?",
"充值说明": "Instrukcije za Napunjavanje",
"充值套餐": "Paketi za Napunjavanje",
"支付金额": "Iznos Plaćanja",
"到账数量": "Broj Pristiglih",
"充值时间": "Vreme Napunjavanja",
"到账金额": "Pristigla Suma",
"赠送金额": "Poklon Izbor",
"提现设置": "Podešavanja Isplate",
"是否开启提现": "Omogući isplate",
"注：如开启则移动端显示余额提现": "Napomena: Ako je omogućeno, mobilni uređaj će prikazati opciju za povlačenje sredstava",
"提现比例": "Odnos Isplate",
"注：提现比例请填写数字0~100": "Napomena: Molimo unesite odnos isplate između 0 i 100",
"例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)": "Primer: Iznos Isplate (100.00 juana) * Odnos Isplate (100%) = Stvarni Pristigli Iznos (100€)",
"最低提现金额": "Minimalni Iznos Isplate",
"注：最低提现金额多少元": "Napomena: Koliko iznosi minimalni iznos isplate u juanima?",
"请选择状态": "Molimo izaberite status",
"提现方式": "Način Isplate",
"请选择提现方式": "Molimo izaberite način isplate",
"微信": "WeChat",
"支付宝": "Alipay",
"银行卡": "Bankovna Kartica",
"请输入用户ID": "Molimo unesite ID korisnika",
"请输入昵称/姓名/手机号": "Molimo unesite nadimak/ime/broj telefona",
"提现信息": "Informacije o Isplati",
"支付宝名称": "Naziv Alipay Računa",
"支付宝账号": "Alipay Račun",
"银行名称": "Ime Banke",
"开户名": "Ime na Računu",
"银行卡号": "Broj Bankovne Kartice",
"申请时间": "Vreme Zahteva",
"审核时间": "Vreme Pregleda",
"微信付款": "WeChat Plaćanje",
"该操作 将使用微信支付企业付款到零钱功能，确定打款吗？": "Ova operacija će upotrebiti WeChat-ovu funkciju preduzeća plaćanja na novčaniku. Da li želite nastaviti?",
"添加充值套餐": "Dodaj Paket za Napunjavanje",
"套餐名称": "Naziv Paketa",
"请输入套餐名称": "Molimo unesite naziv paketa",
"请输入支付金额": "Molimo unesite iznos plaćanja",
"请输入赠送金额": "Molimo unesite iznos poklona",
"请输入到账金额": "Molimo navedite iznos pristiglih",
"请输入排序": "Molimo unesite redosled",
"用户ID": "ID Korisnika",
"会员卡管理": "Upravljanje Članskim Karticama",
"领取记录": "Zapisi o Primanju",
"删除记录": "Brisanje Zapisa",
"请输入关键词": "Molimo unesite ključnu reč",
"过期": "Isteklo",
"有效": "Validno",
"客户信息": "Informacije o Klijentima",
"会员卡名称": "Naziv Članske Kartice",
"有效期": "Period Važenja",
"折": "Popust",
"领取时间": "Vreme Primanja",
"延期": "Produži",
"撤销": "Povuci",
"添加会员卡": "Dodaj Člansku Karticu",
"启用": "Aktiviraj",
"关闭": "Isključi",
"月": "Mesec",
"永久有效": "Neprekidno Važeće",
"领取数量": "Broj Primalaca",
"发卡": "Izdaj Karticu",
"领取设置": "Podešavanja za Primanje",
"请检查必填项是否填写完整": "Molimo proverite da li su obavezna polja potpuno popunjena",
"领取人数": "Broj Primalaca",
"删除时间": "Vreme Brisanja",
"请填写有效期": "Molimo unesite period važenja",
"有效期限（月），0为永久有效": "Period važenja (u mesecima), 0 za neograničeno važenje",
"请填写价格": " LJubazno navedite cenu",
"用户购买会员卡需要支付的金额，0为用户免费领取": "Iznos koji korisnici treba da plate za kupovinu članske kartice, 0 za besplatno izdavanje",
"使用须知": "Smernice za Korišćenje",
"请填写使用须知": "Molimo navedite uputstva za korišćenje",
"请填写会员卡名称": "Molimo unesite naziv članske kartice",
"卡片类型": "Tip Kartice",
"卡片样式": "Stil Kartice",
"请填写排序": "Molimo unesite redosled",
"会员权益": "Prava Članstva",
"无折扣": "Bez Popusta",
"请填写折扣": "Molimo unesite popust",
"开卡赠送": "Poklon pri Aktivaciji Kartice",
"优惠券": "Kupon",
"请填写积分数量": "Molimo navedite količinu bodova",
"请填写余额数量": "Molimo navedite iznos stanja",
"请填写优惠券": "Molimo unesite kupon",
"添加优惠券": "Dodaj Kupon",
"券名称": "Naziv Kupona",
"每人领取数量": "Količina po osobi",
"选择优惠券弹出层": "Izbor Popup Kupona",
"您已经选择了十五张优惠券，若要更换请删除其他优惠券！": "Već ste odabrali petnaest kupona, molimo obrišite druge ako želite da ih zamenite!",
"产品编码": "Kôd Proizvoda",
"请填写产品编码": "Molimo unesite kôd proizvoda",
"产品划线价": "Cena Proizvoda na Listi",
"请填写产品划线价": "Molimo navedite cenu proizvoda na listi",
"商品重量": "Težina Proizvoda",
"请填写商品重量": "Molimo navedite težinu proizvoda",
"批量设置": "Postavke za Masovno",
"划线价": "Lista Cena",
"重量": "Težina",
"应用": "Primeni",
"规格图片": "Slika Specifikacije",
"规格值": "Vrednost Specifikacije",
"请输入规格值": "Molimo unesite vrednost specifikacije",
"请填写规则名或规则值": "Molimo unesite ime pravila ili vrednost pravila",
"规格值不能为空": "Vrednost specifikacije ne može biti prazna",
"卡名称": "Ime Kartice",
"卡ID": "ID Kartice",
"无": "Nijedno",
"选择会员": "Izaberite Člana",
"恭喜你，发卡成功": "Čestitamo, uspešno izdavanje kartice",
"副卡数": "Broj Pratećih Kartica",
"张": "komada",
"选择日期": "Izaberite Datum",
"签到设置": "Postavke Prijavljivanja",
"签到记录": "Zapisi Prijavljivanja",
"是否开启签到有礼": "Omogući Nagrade za Prijavljivanje",
"每日签到固定奖励": "Fiksna Nagrada za Dnevno Prijavljivanje",
"每日签到送": "Nagrada za Dnevno Prijavljivanje",
"递增奖励": "Povećanje Nagrada",
"有": "Da",
"第二天起递增奖励": "Povećanje Nagrada Od Drugog Dana",
"第": "Dan",
"天起不再递增": "Povećanje se neće nastaviti od ovog dana",
"连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算）": "Dodatne Nagrade za Kontinuirano Prijavljivanje (Kada dostignete najveći broj dana za dodatne nagrade, dalje prijavljivanje neće doneti dodatne nagrade; brojač se resetuje nakon propuštenog prijavljivanja)",
"额外奖励": "Dodatna Nagrada",
"连续签到": "Kontinuirano Prijavljivanje",
"请输入连续签到天数": "Molimo unesite broj uzastopnih dana prijavljivanja",
"积分奖励": "Nagrade u Bodovima",
"送": "darovanje",
"请输入连续签到天数的积分": "Molimo unesite bodove za uzastopne dane prijavljivanja",
"规则": "Pravila",
"规则说明": "Objašnjenje Pravila",
"请添加至少一项额外奖励！": "Molimo dodajte bar jednu dodatnu nagradu!",
"天数不能为空！": "Dani ne smeju biti prazni!",
"请输入连续签到积分数！": "Molimo unesite broj bodova za uzastopna prijavljivanja!",
"每日签到送积分有误": "Greška u nagradi za dnevno prijavljivanje",
"请输入第二天起递增积分数": "Molimo unesite broj bodova za povećanje od drugog dana",
"请输入第几天不再递增": "Molimo unesite dan kada povećanje prestaje",
"恭喜你，保存成功": "Čestitamo, uspešno sačuvano",
"连续签到天数": "Broj Uzastopnih Dana Prijavljivanja",
"不限": "Neograničeno",
"签到时间": "Vreme Prijavljivanja",
"时间": "Vreme",
"请输入用户昵称": "Molimo unesite nadimak korisnika",
"签到日期": "Datum Prijavljivanja",
"活动奖品": "Nagrade za Aktivnosti",
"取号记录": "Zapisi Rezervacija Brojeva",
"桌号管理": "Upravljanje Stolovima",
"取号设置": "Postavke Rezervacije Brojeva",
"请输入手机号": "Molimo unesite broj telefona",
"待叫号": "Za Pozivanje",
"就餐号": "Broj za Jelo",
"就餐人数": "Broj Osoba za Sto",
"桌位名称": "Naziv Stola",
"取号时间": "Vreme Rezervacije Broja",
"待取号": "Za Rezervaciju",
"已入座": "Sednica",
"已过号": "Propušteno",
"是否开启打印": "Omogući Štampanje",
"须知": "Uputstva",
"请输入须知": "Molimo unesite uputstva",
"商家说明": "Opis Prodavca",
"请输入商家说明": "Molimo unesite opis prodavca",
"取号规则": "Pravila Rezervacije Brojeva",
"等待时间": "Vreme Čekanja",
"人数最小值": "Minimalni Broj Osoba",
"人数最大值": "Maksimalni Broj Osoba",
"等待时间(分钟)": "Vreme Čekanja (minuti)",
"请输入桌位名称": "Molimo unesite naziv stola",
"请输入人数最小值": "Molimo unesite minimalni broj osoba",
"请输入人数最大值": "Molimo unesite maksimalni broj osoba",
"请输入等待时间": "Molimo unesite vreme čekanja",
"商品设置": "Postavke Proizvoda",
"兑换记录": "Zapisi Zamene",
"活动名称": "Naziv Aktivnosti",
"请输入活动名称": "Molimo unesite naziv aktivnosti",
"活动列表": "Lista Aktivnosti",
"添加活动": "Dodaj Aktivnost",
"活动价格": "Cena Aktivnosti",
"发放数量": "Količina za Distribuciju",
"参与人数": "Broj Učesnika",
"终止": "Prekini",
"购买记录": "Zapisi Kupovine",
"新增活动会场": "Dodaj Novu Lokaciju za Aktivnosti",
"活动标题": "Naslov Aktivnosti",
"请输入活动标题": "Molimo unesite naslov aktivnosti",
"活动日期": "Datum Aktivnosti",
"礼包设置": "Postavke Darovnog Paketa",
"优惠券id": "ID Kupona",
"购买设置": "Postavke Kupovine",
"购买金额": "Iznos Kupovine",
"会员购买等级": "Nivo Kupovine za Članove",
"指定等级": "Odredjeni Nivo",
"购买次数": "Broj Kupovina",
"限购": "Ograničenja Kupovine",
"每人限购": "Ograničenje Kupovine Po Osobi",
"次": "Puta",
"发放设置": "Postavke Distribucije",
"请输入发放数量": "Molimo unesite količinu za distribuciju",
"返回": "Nazad",
"请勿重复添加": "Molimo izbegavajte duplo dodavanje",
"至少选择一个优惠券": "Odaberite bar jedan kupon",
"新增活动": "Dodaj Novu Aktivnost",
"券包设置": "Postavke Paketa Kupona",
"下载推广码": "Preuzmi Kod za Promociju",
"下载类型": "Vrsta Preuzimanja",
"使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致": "Pre korišćenja ove funkcije, posetite backend mini programa i podesite prikaz javnog naloga u sekciji 'Podešavanja'-'Postavljanje Interfejsa'-'Komponenta Za Praćenje Javnog Naloga'. Napomena: Podesiti javni nalog mora se poklapati sa entitetom mini programa",
"去配置": "Idi na Konfiguraciju",
"若没有配置公众号，功能将不生效": "Ako nije podešeno ovoliki javni nalog, funkcija neće biti aktivna",
"在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力": "Samo kada mini program otvorite iz sledećih scenarija, možete koristiti funkciju za vođenje u praćenje javnog naloga",
"当小程序从扫小程序码打开时": "Kada se mini program otvori skeniranjem mini programa koda",
"当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态": "Kada se vratite u mini program iz drugog mini programa, ako prethodni mini program nije uništen, komponenta će sačuvati stanje iz poslednjeg otvaranja mini programa",
"公众号关注": "Pratite Javni Nalog",
"新客设置": "Podešavanja za Nove Korisnike",
"是否开启活动": "Da li je aktivnost omogućena?",
"活动时间": "Period Aktivnosti",
 "背景图": "Pozadinska Slika",
"赠送优惠券": "Poklanjanje Kupona",
"请选择优惠券": "Molimo odaberite kupon",
"赠送积分": "Poklanjanje Poena",
"请输入赠送积分": "Molimo unesite poene koje želite pokloniti",
"直播同步": "Sinhronizacija Uživo Emitovanja",
"同步直播": "Sinhronizuj Uživo Emitovanje",
"请输入直播间名称/主播昵称": "Molimo unesite naziv sobe uživo/voditeljski nadimak",
"直播间ID": "ID Sobe Uživo",
"直播间名称": "Naziv Sobe Uživo",
"主播昵称": "Nadimak Voditelja",
"直播开始时间": "Vreme Početka Uživo Emitovanja",
"直播结束时间": "Vreme Završetka Uživo Emitovanja",
"直播间状态": "Status Sobe Uživo",
"置顶": "Zakači na Vrh",
"未置顶": "Nije Zakačen",
"已置顶": "Zakačen",
"设为置顶": "Postavi kao Vrh",
"取消置顶": "Odkači sa Vrha",
"直播中": "Uživo",
"未开始": "Nije Počelo",
"已结束": "Završeno",
"禁播": "Zabrana Emitovanja",
"暂停": "Pauza",
"异常": "Abnormalno",
"已过期": "Isteklo",
"置顶成功": "Uspešno Zakačeno na Vrh",
"邀请活动": "Dogadjaj Poziva",
"个人中心图片": "Slika Ličnog Centra",
"请输入用户昵称/手机号": "Molimo unesite korisničko ime/naziv telefona",
"邀请人": "Pozivaoc",
"被邀请人": "Pozvani",
"参加时间": "Vreme Pristupanja",
"个人中心显示": "Prikaz Ličnog Centra",
"参与记录": "Zapisi Učešća",
"礼品记录": "Zapisi Darova",
"推广二维码": "Promotivni QR Kod",
"编辑活动会场": "Uredi Mesto Događaja",
"请输入分享标题": "Molimo unesite naslov deljenja",
"请输入分享内容": "Molimo unesite sadržaj deljenja",
"分享内容": "Deljeni Sadržaj",
"分享图": "Deljeni Sadržaj",
"个人中心状态": "Status Ličnog Centra",
"邀请成功的条件": "Uslovi Za Uspešan Poziv",
"邀请成为会员": "Pozvati Da Postane Član",
"邀请成为会员且消费": "Pozvati Da Postane Član i Potroši",
"礼品设置": "Postavke Darova",
"奖项": "Nagrada",
"每邀请": "Za Svaki Poziv",
"人获得礼品": "Osoba Dobija Dar",
"添加奖励项": "Dodaj Nagradnu Stavku",
"请上传背景图": "Molimo postavite pozadinsku sliku",
"请上传分享图": "Molimo postavite sliku za deljenje",
"请添加奖项": "Molimo dodajte nagradu",
"开启首页推送": "Omogući Push Na Početnoj Strani",
"建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗": "Preporučuje se promena aktivnosti; menjanjem ovog imena prilagodiće se iskačući prozor na početnoj strani trgovine prema ovom imenu",
"类型": "Tip",
"图文": "Slika Tekst",
"纯图": "Čista Slika",
"领取优惠券": "Preuzmi Kupon",
"请输入标题": "Molimo unesite naslov",
"弹窗图片": "Slika Iskačućeg Prozora",
"图片为2M以内大小，格式限png，jpg格式": "Slika treba da bude unutar 2MB i u PNG ili JPG formatu",
"建议尺寸": "Preporučena Veličina",
"按钮文案": "Tekst Dugmeta",
"简介说明": "Kratko Objašnjenje",
"请输入说明": "Molimo unesite objašnjenje",
"点击选择你要链接的位置": "Kliknite da odaberete poziciju za povezivanje",
"跳转地址": "Adresa Preusmeravanja",
"最多可以添加三张": "Maksimalno Možete Dodati Tri",
"最多添加3张优惠券": "Maksimum Dodavanje: 3 Kupona",
"标题不能为空": "Naslov Ne Može Biti Prazan",
"请选择跳转链接": "Izaberite Link za Preusmeravanje",
"请选择优惠卷": "Odaberite Kupon",
"请上传图片": "Molimo postavite sliku",
"团购订单": "Porudžbine Grupne Kupovine",
"团购管理": "Upravljanje Grupnom Kupovinom",
"团购设置": "Postavke Grupne Kupovine",
"订单设置": "Postavke Porudžbine",
"未支付订单": "Neplaćene Porudžbine",
"请输入关闭时间": "Molimo unesite vreme zatvaranja",
"团购保障": "Zaštita Grupne Kupovine",
"使用门店": "Korišćenje Prodavnice",
"待付款": "Nepoplaćeno",
"待使用": "Čeka na Korišćenje",
"已取消": "Otkazano",
"已退款": "Refundirano",
"使用门店名称": "Naziv Prodavnice za Korišćenje",
"门店联系人": "Kontakt Osoba Prodavnice",
"门店电话": "Telefon Prodavnice",
"团购信息": "Informacije o Grupnoj Kupovini",
"券码信息": "Informacije o Kodu Kupona",
"核销券码": "Unos Koda Kupona",
"添加团购": "Dodaj Grupnu Kupovinu",
"团购名称": "Naziv Grupne Kupovine",
"销售价格": "Cena Prodaje",
"虚拟销量": "Virtualna Prodajna Stanja",
"部分": "Deo",
"基础设置": "Osnovna Konfiguracija",
"购买须知": "Uputstva za Kupovinu",
"团购详情": "Detalji grupne kupovine",
"团购须知": "Uputstva za grupnu kupovinu",
"请输入团购名称": "Unesite naziv grupe za kupovinu",
"到期类型": "Tip isteka",
"购买后生效": "Važi nakon kupovine",
"固定时间": "Fiksno vreme",
"有效天数": "Period važenja u danima",
"请输入有效天数": "Unesite period važenja u danima",
"有效时间": "Važeće vreme",
"请输入有效时间": "Unesite važeće vreme",
"团购图片": "Slika grupe za kupovinu",
"请上传团购图片": "Molimo postavite sliku grupe za kupovinu",
"请输入划线价格": "Unesite cenu sa precrtanim brojem",
"请输入销售价格": "Unesite prodajnu cenu",
"请输入虚拟销量": "Unesite virtuelnu prodaju",
"适用门店": "Primjenjive prodavnice",
"请选择门店": "Izaberite prodavnicu",
"团购状态": "Status grupe za kupovinu",
"每日限购数量": "Dnevni limit kupovine",
"每个会员每日购买的最大数量，0为不限购": "Maksimalna količina koju svaki član može kupiti dnevno; 0 za neograničeno",
"商家名称": "Ime trgovca",
"平台": "Platforma",
"满类型": "Tip popusta",
"满额": "Puno",
"满件数": "Broj punjenja",
"满值": "Puna vrednost",
"减类型": "Tip sniženja",
"减金额": "Iznos sniženja",
"打折": "Popust",
"减值": "Iznos sniženja",
"编辑活动": "Uredi aktivnost",
"满金额": "Puna cena",
"请输入满值": "Unesite punu vrednost",
"如果是打折，填写80，表示打8折": "Ako je popust, unesite 80 za 20% popusta",
"满额免配送费设置": "Besplatna dostava preko punog iznosa",
"是否开启满额免配送费": "Omogućite besplatnu dostavu preko punog iznosa",
"单笔订单满": "Jedno naručivanje preko",
"如果开启满额免配送费，设置0为全场免配送费": "Ako je besplatna dostava omogućena, postavite 0 za celokupno naručivanje",
"入驻申请": "Prijava za smještaj",
"配送员": "Dostavljači",
"配送订单": "Dostavna naručivanja",
"提现申请": "Zahtjev za povlačenje",
"配送设置": "Postavke dostave",
"退出申请": "Izlazni zahtev",
"正常": "Normalno",
"押金": "Depozit",
"累计佣金": "Akumulirana provizija",
"可提现佣金": "Dostupna provizija za povlačenje",
"已提现佣金": "Već povučena provizija",
"提现明细": "Detalji povlačenja",
"申请条件": "Uslovi prijave",
"结算": "Račun",
"是否开启押金支付": "Omogućite uplatu depozita",
"是否审核": "Potrebna verifikacija",
"需后台审核": "Potrebno je verifikovati",
"无需审核": "Ne zahteva se verifikacija",
"产品列表弹出层": "Popup proizvodne liste",
"已选择该商品": "Proizvod već izabran",
"注：如使用微信支付，则需申请微信支付企业付款到零钱功能": "Napomena: Za WeChat Pay, aplicirajte za prenos novca na račun",
"微信提现方式": "Metoda povlačenja novca putem WeChat-a",
"微信提现到零钱": "Povlačenje na WeChat Wallet",
"商家转账到零钱": "Transakcija trgovca na WeChat Wallet",
"注：根据实际产品开通情况选择": "Izaberite prema stvarnom stanju aktivacije proizvoda",
"最低提现额度": "Minimalni limit povlačenja",
"佣金结算时间": "Vreme izmirenja provizije",
"注：当订单完成n小时后，该订单的配送佣金才会结算到配送员余额，如果设置为0小时，则订单完成时就结算": "Napomena: Provizije se izmiruju n sati nakon završetka narudžbine; Postavite na 0 za trenutno izmirenje",
"请至少选择一种提现方式": "Molimo odaberite barem jedan način povlačenja",
"佣金结算": "Izmirivanje provizije",
"是否结算佣金": "Da li izmirujete proviziju?",
"已结算": "Izmirivanje",
"未结算": "Nije izmireno",
"送达状态": "Status isporuke",
"查看详情": "Pogledaj detalje",
"该操作将使用微信支付企业付款到零钱功能，确定打款吗？": "Ova operacija će koristiti WeChat Enterprise Payment za prenos na Vaš račun. Da li ste sigurni u transakciju?",
"身份证号": "Broj lične karte",
"待交押金": "Čeka se depozit",
"审核方式": "Metoda verifikacije",
"查看": "Pogledaj",
"配送员审核": "Verifikacija dostavljača",
"添加外卖商品": "Dodajte dostavne proizvode",
"序号": "Redni broj",
"活动折扣": "Popust na aktivnosti",
"活动库存": "Zalihe na aktivnostima",
"添加店内商品": "Dodaj unutrašnje proizvode",
"优惠券列表": "Lista kupona",
"发送优惠券": "Pošalji kupone",
"发送对象": "Primalac",
"全站会员": "Svi članovi sajta",
"指定会员": "Odabrani članovi",
"选择会员等级": "Izaberite nivo članstva",
"发送的优惠券会员领取已达到限制数量，将不再发送给该会员": "Primalac je dostigao limit za primanje određenog kupona i više ga neće primiti",
"发送成功": "Uspješno poslato",
"优惠券ID": "ID kupona",
"优惠券名称": "Naziv kupona",
"优惠券类型": "Tip kupona",
"最低消费金额": "Minimalni iznos za potrošnju",
"优惠方式": "Način popusta",
"立减": "Direktno sniženje",
"打": "Popust",
"领取": "Preuzmi",
  "天内有效": "Važeće tokom dana",
"发放总数量": "Ukupna količina distribucije",
"不限制": "Neograničeno",
"已领取数量": "Količina primljena",
"修改优惠券": "Izmeni kupon",
"请输入优惠券名称": "Molimo unesite naziv kupona",
"例如：满100减10": "Na primer: Potroši 100 i dobiješ 10 popusta",
"优惠券颜色": "Boja kupona",
"蓝色": "Plava",
"红色": "Crvena",
"紫色": "Ljubičasta",
"黄色": "Žuta",
"满减券": "Kupon sa popustom",
"折扣券": "Kupon sa stopom popusta",
"减免金额": "Iznos smanjenja",
"请输入减免金额": "Molimo unesite iznos smanjenja",
"折扣率": "Stopa popusta",
"请输入折扣率": "Molimo unesite stopu popusta",
"折扣率范围0-10，9.5代表9.5折，0代表不折扣": "Raspon stope popusta je od 0 do 10. Na primer, 9.5 predstavlja popust od 5%, a 0 ne predstavlja popust",
"请输入最低消费金额": "Molimo unesite minimalni iznos troška",
"后生效": "Efikasan nakon",
"请输入发放总数量": "Molimo unesite ukupnu količinu distribucije",
"限制领取的优惠券数量，-1为不限制": "Ograničite broj kupona koji se mogu primiti, -1 znači bez ograničenja",
"是否显示在领券中心": "Da li je prikazano u centru kupona?",
"新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次": "Pop-up prozor prikazan na slici pojaviće se samo jednom za nove korisnike prilikom njihovog prvog ulaska u mini-program",
"引导收藏": "Vodič za sakupljanje",
"编辑类型": "Vrsta uređivanja",
"生日设置": "Podešavanje rođendana",
"手机短信": "Mobilni SMS",
"分销商用户": "Korisnik distributera",
"分销订单": "Distribucija narudžbi",
"分销海报": "Distributivni plakati",
"推荐人": "Preporučilac",
"下级用户": "Potčinjeni korisnici",
"一级": "Nivo jedan",
"二级": "Nivo dva",
"三级": "Nivo tri",
"成为时间": "Datum postajanja članom",
"下级": "Potčinjeni",
"加入时间": "Datum pridruživanja",
"分销商条件": "Uslovi za distributore",
"佣金设置": "Postavljanje provizije",
"自定义文字": "Prilagođeni tekst",
"申请协议": "Zahtev za ugovor",
"页面背景图": "Slika pozadine stranice",
"分销中心页面": "Stranica distributivnog centra",
"页面标题": "Naslov stranice",
"分销中心": "Distributivni centar",
"非分销商提示": "Upozorenje za ne-distributore",
"您还不是分销商，请先提交申请": "Još uvek niste distributer, molimo pošaljite zahtev prvo",
"申请成为分销商": "Podnesi zahtev za distribuciju",
"立即加入": "Pridruži se odmah",
"可提现": "Dostupno za povlačenje",
"待提现佣金": "Provizija za povlačenje na čekanju",
"待提现": "Na čekanju za povlačenje",
"已提现金额": "Ukupan iznos povučenih sredstava",
"去提现": "Povuci sada",
"申请成为分销商页面": "Stranica za prijavu za distribuciju",
"请填写申请信息": "Molimo popunite informacije za prijavu",
"分销商申请协议": "Ugovor o prijavi distributera",
"申请成为经销商": "Podnesi zahtev za dilerstvo",
"审核中提示信息": "Informacija o čekanju pregleda",
"您的申请已受理，正在进行信息核验，请耐心等待。": "Vaša prijava je primljena i vrši se provera informacija. Molimo sačekajte strpljivo",
"去商城逛逛": "Idi u kupovinu u tržnom centru",
"分销订单页面": "Stranica distribucije narudžbi",
"我的团队页面": "Stranica mog tima",
"我的团队": "Moj tim",
"团队总人数": "Ukupan broj članova tima",
"一级团队": "Primirni tim",
"二级团队": "Sekundarni tim",
"三级团队": "Tersijarni tim",
"提现明细页面": "Stranica detalja o povlačenju",
"审核中": "Na čekanju pregleda",
"申请提现页面": "Stranica zahteva za povlačenje",
"申请提现": "Podnesi zahtev za povlačenje",
"请输入要提取的金额": "Molimo unesite željeni iznos za povlačenje",
"最低提现佣金": "Minimalna provizija za povlačenje",
"提交申请": "Podnesi zahtev",
"佣金结算天数": "Dani za obračun provizije",
"注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算": "Napomena: Provizija od završene narudžbe biće obavljena na saldo distributera nakon n dana. Ako je podešeno na 0 dana, biće obavljeno po završetku narudžbe",
"成为分销商条件": "Uslovi za postajanje distributerom",
"购买指定商品成为分销商": "Postani distributer kupovinom određenih proizvoda",
"购买指定商品付款后自动成为分销商，无需后台审核": "Automatsko postajanje distributerom nakon plaćanja određenih proizvoda, bez potrebe za pregledom sa pozadine",
"选择商品": "Izaberi proizvode",
"成为下线条件": "Uslovi za postajanje potčinjenim",
"首次点击分享链接": "Prvo kliknite na deljeni link",
"一级佣金比例": "Stopa primarne provizije",
"佣金比例范围 0% - 100%": "Raspon stope provizije od 0% do 100%",
"二级佣金比例": "Stopa sekundarne provizije",
"三级佣金比例": "Stopa tersijarne provizije",
"是否开启分销功能": "Aktivirati funkciju distribucije?",
"分销层级": "Nivoi distribucije",
"一级分销": "Primarna distribucija",
"二级分销": "Sekundarna distribucija",
"三级分销": "Tersijarna distribucija",
"分销商内购": "Distributivna interna kupovina",
"如开启，分销商自己购买商品，获得一级佣金": "Ako je omogućeno, distributeri dobijaju primarnu proviziju za kupovine koje su sami obavili",
"分销中心首页": "Početna stranica distributivnog centra",
"尺寸：宽750像素 高度227像素": "Dimenzije: Širina 750 piksela, Visina 227 piksela",
"申请成为分销商页": "Stranica za prijavu za distribuciju",
 "申请提现页": "Stranica zahteva za povlačenje",
"分销海报设置": "Podešavanja distributivnih plakata",
"海报背景图": "Pozadinska slika plakata",
"尺寸：宽750像素 高大于(等于)1200像素": "Dimenzije: Širina 750 piksela, Visina veća od ili jednaka 1200 piksela",
"头像宽度": "Širina avatar-a",
"头像样式": "Stil avatar-a",
"正方形": "Kvadratni",
"圆形": "Kružni",
"昵称字体大小": "Veličina fonta nadimka",
"昵称字体颜色": "Boja fonta nadimka",
"小程序码宽度": "Širina mini programa koda",
"小程序码样式": "Stil mini programa koda",
"分销商": "Distributor",
"一级分销商": "Primarni distributer",
"用户": "Korisnik",
"分销佣金": "Provizija distributera",
"二级分销商": "Sekundarni distributer",
"三级分销商": "Tersijarni distributer",
"分销商审核": "Pregled distributera",
"积分明细": "Detalji bodova",
"变动数量": "Promenljiva količina",
"积分名称": "Naziv bodova",
"例": "Primer",
"修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称": "Nakon izmene naziva bodova, prilagođeni naziv će biti prikazan na svim stranicama na strani kupca",
"商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”": "Biznisi koriste prilagođene nazive bodova za brendiranje. Na primer, JD naziva bodove 'JD Beans', a Taobao ih naziva 'Treasure Coins'",
"积分说明": "Opis bodova",
"积分赠送": "Davanje bodova",
"是否开启购物送积分": "Omogućiti davanje bodova za kupovinu",
"积分赠送规则": "Pravila davanja bodova",
"如开启则订单完成后赠送用户积分": "Ako je omogućeno, bodovi se dodeljuju korisnicima po završetku narudžbe",
"订单确认收货已完成": "Potvrda i prijem narudžbe je završen",
"已完成订单超出后台设置的申请售后期限": "Završene narudžbe premašuju post-servisni period postavljen na pozadini",
"积分赠送比例": "Odnos davanja bodova",
"赠送比例请填写数字0~100；订单的运费不参与积分赠送": "Molimo unesite odnos između 0 i 100; troškovi dostave se ne računaju u davanje bodova",
"S销售统计": "Statistika prodaje",
"会员统计": "Statistika članstva",
"订单概况": "Pregled narudžbi",
"商品概况": "Pregled proizvoda",
"今日": "Danas",
"累积会员数": "Ukupan broj članova",
"新增会员数": "Broj novih članova",
"成交会员数": "Broj članova sa transakcijom",
"排行榜": "Lista najboljih",
"用户消费榜": "Lista potrošača",
"积分排行榜": "Lista bodova",
"邀请人排行榜": "Lista pozivaoca",
"成交会员占比": "Udeo članova sa transakcijom",
"今天": "Danas",
"最近7天": "Poslednjih 7 dana",
"最近30天": "Poslednjih 30 dana",
"最近90天": "Poslednjih 90 dana",
"最近180天": "Poslednjih 180 dana",
"最近1年": "Prošla godina",
"最近2年": "Poslednjih 2 godine",
"所有占比": "Ukupni odnos",
"成交会员": "Članovi sa transakcijom",
"未成交会员": "Članovi bez transakcije",
"新增会员": "Nova članstva",
"最近一周": "Prošle nedelje",
"最近一个月": "Prošli mesec",
"最近三个月": "Poslednja tri meseca",
"选择店铺": "Izaberi prodavnicu",
"查询日期": "Datum upita",
"近七天": "Poslednjih sedam dana",
"近十五天": "Poslednjih petnaest dana",
"自定义时间": "Prilagođeno vreme",
"日期": "Datum",
"有效订单数": "Broj validnih narudžbi",
"选择时间": "Izaberi vreme",
"交易统计": "Statistika transakcija",
"订单数": "Broj narudžbi",
"客单价": "Prosečna vrednost narudžbe",
"付款订单": "Plaćene narudžbe",
"付款人数": "Broj platioca",
"商品统计": "Statistika proizvoda",
"在售商品": "Proizvodi na prodaju",
"件": "Komad",
"已付款商品": "Plaćeni proizvodi",
"销量TOP10": "Top 10 prodaje",
"浏览TOP10": "Top 10 pregleda",
"浏览": "Pregled",
"排行类型": "Tip rangiranja",
"商品总数": "Ukupan broj proizvoda",
"已上架商品": "Postavljeni proizvodi",
"已下架商品": "Uklonjeni proizvodi",
"商品导出": "Izvoz proizvoda",
"商品总销量": "Ukupna prodaja proizvoda",
"商品总销售额": "Ukupan iznos prodaje proizvoda",
"资产总览": "Pregled imovine",
"财务对账": "Finansijsko izmirenje",
"交易记录": "Zapisnik transakcija",
"店铺结算": "Finansijsko stanje prodavnice",
"待结算金额": "Iznos za izmirenje",
"已结算金额": "Izregulisan iznos",
"交易概况": "Pregled transakcija",
"外卖统计": "Statistika dostave",
"店内统计": "Statistika prodavnice",
 "订单类型": "Tip narudžbe",
"应收金额": "Iznos za naplatu",
"实付金额": "Plaćeni iznos",
"账户概况": "Pregled naloga",
"订单编号": "Broj narudžbe",
"支付状态": "Status plaćanja",
"付款方式": "Način plaćanja",
"订单费用": "Troškovi narudžbe",
"优惠": "Popust",
"商户实际收入": "Stvarni prihod trgovca",
"商品ID": "ID proizvoda",
"小计": "Međuzbir",
"请输入提现金额": "Unesite iznos za povlačenje",
"请输入打款方式": "Unesite način plaćanja",
"支付宝真实姓名": "Pravo ime Alipay-a",
"请输入支付宝真实姓名": "Unesite pravo ime Alipay-a",
"开户行名称": "Naziv banke",
"银行开户名": "Ime bankovnog računa",
"真实姓名": "Pravo ime",
"应付金额": "Iznos za plaćanje",
"实付总额": "Ukupan iznos plaćenog",
"商户": "Trgovac",
"结算金额": "Iznos izmirenja",
"店铺结算金额": "Iznos izmirenja prodavnice",
"操作提示": "Saveti za rukovanje",
"订单结算金额 = 店铺结算总金额(含运费)": "Iznos izmirenja narudžbe = Ukupan iznos izmirenja prodavnice (uključujući troškove dostave)",
"店铺收入金额 = 店铺结算总金额 - 店铺退款金额": "Prihod prodavnice = Ukupan iznos izmirenja prodavnice - Izvratiti iznos prodavnice",
"订单日期": "Datum narudžbe",
"订单结算金额": "Iznos izmirenja narudžbe",
"配送费金额": "Iznos troškova dostave",
"商品编码": "Šifra proizvoda",
"可用余额": "Dostupni saldo",
"提现概况": "Pregled povlačenja",
"搜索": "Traži",
"支出": "Troškovi",
"金额": "Iznos",
"收支类型": "Vrsta prihoda i troškova",
"确认要退吗?": "Potvrdite da želite da vratite?",
"申请成功": "Zahtev uspešan",
"门店总金额": "Ukupan iznos prodavnice",
"累计收入": "Akumulirani prihod",
"访客数": "Broj posetilaca",
"访问量": "Količina poseta",
"店铺收藏数": "Broj omiljenih prodavnica",
"商品收藏数": "Broj omiljenih proizvoda",
"访问数": "Broj poseta",
"收藏数": "Broj omiljenih",
"数": "Broj",
"待支付": "Nepoplaćeno",
"实际到账": "Stvarno primljeni iznos",
  // =====================  数据统计 end   ==========

  // ==================== 设置 start ================
 "商城设置": "Podešavanja prodavnice",
"物流公司": "Logistička kompanija",
"chatgpt设置": "ChatGPT Postavke",
"消息设置": "Postavke poruka",
"短信设置": "Postavke SMS-a",
"上传设置": "Postavke za postavljanje",
"清理缓存": "Brisanje keš memorije",
"网址后缀英文名称": "Englesko ime za sufiks veb adrese",
"英文名称": "Englesko ime",
"默认头像": "Podrazumevani avatar",
"英文名称必须只包含数字和英文字母": "Englesko ime mora sadržati samo brojeve i slova",
"恭喜你，商城设置成功": "Čestitamo, postavke prodavnice uspešno su primenjene",
"表单数据不符合规则": "Podaci obrasca nisu u skladu sa pravilima",
"剩余额度": "Preostali limit",
"余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用": "Kada je saldo nedovoljan, funkcije poput Inteligentne korisničke podrške, AI Magičnog Kreiranja i Višejezičnog Prevoda neće biti dostupne",
"使用明细": "Detalji korišćenja",
"消费": "Potrošnja",
"额度": "Limit",
"数据缓存": "Keširanje podataka",
"恭喜你，清理成功": "Čestitamo, čišćenje je uspešno",
"管理员列表": "Lista administratora",
"角色管理": "Upravljanje ulogama",
"登录日志": "Evidencija prijava",
"操作日志": "Evidencija operacija",
"添加管理员": "Dodaj administratora",
"管理员ID": "ID administratora",
"用户名": "Korisničko ime",
"所属角色": "Dodeljena uloga",
"超级管理员": "Super administrator",
"所属门店": "Pridružena prodavnica",
"门店状态": "Status prodavnice",
"已删除": "Izbrisano",
"未删除": "Nije izbrisano",
"账号状态": "Status naloga",
"恭喜你，该管理员删除成功": "Čestitamo, administrator uspešno izbrisan",
"请输入用户名": "Unesite korisničko ime",
"修改管理员": "Izmeni administratora",
"添加角色": "Dodaj ulogu",
"角色ID": "ID uloge",
"角色名称": "Ime uloge",
"恭喜你，该角色删除成功": "Čestitamo, uloga uspešno izbrisana",
"编辑角色": "Uredi ulogu",
"请输入角色名称": "Unesite ime uloge",
"权限列表": "Lista dozvola",
"请输入用户名和真实姓名": "Unesite korisničko ime i pravo ime",
"登录状态": "Status prijave",
"全部标记为已读": "Označi sve kao pročitano",
"公告详情": "Detalji obaveštenja",
"全部标记为已读消息吗?": "Da li želite da označite sve poruke kao pročitane?",
"操作成功!": "Operacija uspešna!",
"已取消操作": "Operacija otkazana",
"订单流程设置": "Postavke procesa narudžbe",
"已支付订单": "Plaćene narudžbe",
"分钟后自动关闭": "automatsko zatvaranje nakon minuta",
"订单下单未付款，n分钟后自动关闭，设置0不自动关闭": "Narudžbe koje su napravljene ali nisu plaćene, automatsko zatvaranje nakon n minuta, postavite na 0 za neautomatsko zatvaranje",
"分钟后自动核销": "automatska verifikacija posle minuta",
"如果在期间未核销，系统自动完成核销，设置0不自动核销": "Ako se ne verifikuje u datom periodu, sistem će automatski verifikovati, postavite na 0 za neautomatsku verifikaciju",
"积分商城订单流程设置": "Postavke procesa narudžbe u Mreži bodova",
"已发货订单": "Narudžbe poslate",
"天后自动核销": "automatska verifikacija posle dana",
"不包括桌台订单": "ne uključujući narudžbe stola",
"恭喜你，交易设置成功": "Čestitamo, postavke transakcije su uspešno primenjene",
  // ==================== 设置 end ================
  // ==================== Layout start ===========
 "当前版本": "Trenutna verzija",
"试用版": "Probna verzija",
"专业版": "Profesionalno izdanje",
"高级版": "Napredno izdanje",
"至尊版": "Maksimalno izdanje",
"到期日期": "Datum isteka",
"永不过期": "Nikad ne ističe",
"欢迎您": "Dobrodošli",
"修改密码": "Promeni lozinku",
"此操作将退出登录, 是否继续?": "Ova operacija će vas odjaviti, želite li nastaviti?",
"原始密码": "Originalna lozinka",
"新密码": "Nova lozinka",
"确认新密码": "Potvrdi novu lozinku",
"系统公告": "Sistemsko saopštenje",
"请至少选择一件产品商品！": "Molimo odaberite barem jedan proizvod!",
"超链接设置": "Postavke hiperlinka",
"图像预览": "Pregled slike",
"页面": "Stranica",
"当前链接": "Trenutni link",
"暂无": "Nema",
"页面路径": "Putanja stranice",
"注意一": "Beleška jedan",
"注意二": "Beleška dva",
"注意三": "Beleška tri",
"同一个小程序链接其他小程序，最多只能链接10个，超过将不生效": "Za isti mini-program koji se povezuje s drugim mini-programima, dozvoljeno je maksimalno 10 veza; prekoračenje ovog ograničenja će ih učiniti neefikasnim",
"不能填写自身小程序appid": "Ne možete popuniti appid trenutnog mini programa",
"小程序链接留空默认跳到小程序首页": "Ako ostavite prazno polje za link mini programa, automatski će vas odvesti na početnu stranicu mini programa",
"分类": "Kategorija",
"选择": "Izaberite",
"签到": "Potpisivanje",
"积分商城": "Trgovina bodovima",
"秒杀": "Rasprodaja",
"拼团": "Grupna kupovina",
"砍价": "Pregovaranje",
"领券中心": "Centar za kupon",
"生日有礼": "Rodjendanski poklon",
"链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转": "Povezana web stranica mora podržavati SSL i početi sa https://, inače neće moći biti preusmerena",
"链接的域名必须是备案域名，否则无法跳转": "Povezani domen mora biti registrovan, inače neće moći biti preusmeren",
"您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？": "Vaša web stranica mora biti dodata na poslovni domen WeChat Mini Program Public Platforme, možete li pružiti više detalja?",
"选择文章列表": "Odaberi listu članaka",
"文章标题": "Naslov članka",
"文章分类": "Kategorija članka",
"选择规格": "Odaberi specifikacije",
"产品/规格": "Proizvod/Specifikacije",
"已选": "Odabrano",
"查看物流": "Pogledajte logistiku",
"请输入收货人": "Unesite primaoca",
"请输入收获电话": "Unesite broj telefona primaoca",
"省": "Pokrajina",
"市": "Grad",
"区": "Okrug",
"现金收款": "Gotovinski plaćanje",
"余额收款": "Plaćanje saldo",
"其他方式": "Druge metode",
"请输入会员ID号查询会员，输入完毕后点击确认": "Molimo unesite ID člana kako biste pronašli člana, zatim kliknite potvrdi kada završite",
"请输入会员ID": "Molimo unesite ID člana",
"会员昵称": "Pseudonim člana",
"余额总计": "Ukupan saldo",
"登录会员仅作为积分累计，无法享受其他优惠": "Prijavljeni članovi mogu samo sakupljati poene i ne mogu koristiti druge popuste",
"取消收款": "Otkaži plaćanje",
"收款": "Primi plaćanje",
"请输入会员手机号": "Molimo unesite broj telefona člana",
"该用户不存在": "Ovaj korisnik ne postoji",
"注册": "Registracija",
"平台名称": "Ime platforme",
"请输入平台名称": "Molimo unesite ime platforme",
"所在地区": "Lokacija",
"请选择所在地区": "Molimo odaberite lokaciju",
"平台账户名": "Ime naloga platforme",
"请输入平台账户名": "Molimo unesite ime naloga platforme",
"平台账户密码": "Lozinka naloga platforme",
"是否连锁": "Da li je lanac?",
"是": "Da",
"否": "Ne",
"请输入您的地址": "Molimo unesite vašu adresu",
"请输入您的联系电话": "Molimo unesite vaš kontakt telefon",
"请输入您的联系邮箱": "Molimo unesite vaš kontakt email",
"联系邮箱": "Kontakt email",
"不能全是空格": "Ne može biti samo razmaka",
"不能包含空格": "Ne može sadržavati razmake",
"长度不能小于6位": "Dužina ne sme biti manja od 6 karaktera",
"请填写确认密码": "Molimo unesite potvrdnu lozinku",
"确认密码不一致": "Lozinke se ne podudaraju",
"联系电话和联系邮箱至少填写一个": "Molimo unesite bar jedan kontakt telefon ili email",
"注册成功,请前往登录": "Registracija uspešna, molimo nastavite na prijavu",
"清空": "Isprazni",
"确认": "Potvrdi",
"限时免费": "Ograničeno vreme besplatno",
  // ==================== Components end     =========


  // ==================== 其它  start  ================
  '菜品总量': 'Ukupan broj jela',
'菜品排行榜': 'Tabela rangiranja jela',
'商家信息': 'Informacije o poslovanju',
'与店内营业时间相同': 'Isto kao radno vreme u lokalu',
'菜品': 'Jelo',
'菜品分类': 'Kategorija jela',
'添加菜品': 'Dodaj jelo',
'通告': 'Obaveštenje',
'商家店名': 'Naziv poslovanja',
'请输入商家店名': 'Molimo unesite naziv poslovanja',
'温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱': 'Veseli podsjetnik: Nakon odabira, molimo ne menjajte nasumično kako biste izbjegli nered u podacima o jelima u lokalu',
'网址后缀设置': 'Postavka sufiksa URL-a',
'选填，设置后缀可替换下列网址末尾的数字id，方便记忆': 'Opciono, postavljanje sufiksa može zameniti numerički ID na kraju sledećih URL-ova, olakšavajući pamćenje',
'网址设置': 'Postavljanje URL-a',
'手机网站二维码': 'QR kod mobilne web stranice',
'按菜品收费': 'Naplata po jelu',
'外卖菜品': 'Jela za poneti',
'店内菜品': 'Jela u lokalu',
'菜品管理': 'Upravljanje jelima',
'菜品名称': 'Naziv jela',
'请输入菜品名称': 'Molimo unesite naziv jela',
'此菜品正在参加活动，不能修改规格': 'Ovo jelo učestvuje u aktivnosti i ne može mu se menjati specifikacija',
'通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。': 'Putem tehnologije veštačke inteligencije, detaljne informacije o jelu kao što su sastojci, prodajne karakteristike, i ukusi mogu se automatski popuniti na osnovu naziva jela.',
'请填写菜品详情': 'Molimo unesite detalje o jelu',
'菜品详情': 'Detalji o jelu',
'菜品图片': 'Slika jela',
'请上传菜品图片': 'Molimo postavite sliku jela',
'AI未识别到您的菜品图片': 'AI nije prepoznao sliku vašeg jela',
'本菜品正在参加活动，不能删除规格！': 'Ovo jelo učestvuje u aktivnosti i ne može mu se obrisati specifikacija!',
'菜品加料': 'Dodatak jelima',
'菜品状态': 'Status jela',
'选择菜品状态': 'Izaberite status jela',
'菜品排序': 'Sortiranje jelā',
'请填写菜品名称': 'Molimo unesite naziv jela',
'你选择菜品分类': 'Izabrali ste kategoriju jela',
'菜品卖点': 'Prodajne karakteristike jela',
'菜品属性': 'Atributi jela',
'菜品同步': 'Sinhronizacija jelā',
'是否同步菜品至外卖': 'Da li sinhronizovati jelā s dostavom',
'是否同步菜品至店内': 'Da li sinhronizovati jelā s prodajom u lokalu',
'搜索菜品': 'Pretražite jela',
'菜品原价': 'Početna cena jela',
'菜品来源': 'Izvor jela',
'菜品列表': 'Lista jelā',
'菜品价格': 'Cena jela',
'菜品销量': 'Prodaja jela',
'通告管理': 'Upravljanje obaveštenjīma',
'添加通告': 'Dodaj obaveštenje',
'通告ID': 'ID obaveštenja',
'通告标题': 'Naslov obaveštenja',
'通告分类': 'Kategorija obaveštenja',
'通告排序': 'Sortiranje obaveštenja',
'通告状态': 'Status obaveštenja',
'通告内容': 'Sadržaj obaveštenja',
'编辑通告': 'Uredi obaveštenje',
'AI助理形象选择': 'Izbor slike AI asistenta',
'菜品信息': 'Informacije o jelu',
'菜品总价': 'Ukupna cena jelā',
'请按实际店名填写，将显示在商家点餐网站上': 'Molimo popunite prema stvarnom nazivu poslovanja, pojaviće se na web stranici narudžbine poslovanja',
'首次添加桌位请先添加桌位类型': 'Molimo dodajte tipove stolova pre dodavanja stolova prvi put',
'首次添加桌位请先添加区域': 'Molimo dodajte regije pre dodavanja stolova prvi put',
'设置店内区域，如A区、B区、大厅、包厢等': 'Postavite zone unutar lokala, kao što su Zona A, Zona B, Glavna sala, Privatne sobe, itd.',
'设置桌位类型，如二人桌、四人桌、大桌、小桌等': 'Postavite tipove stolova, kao što su dvosedi, četvorosedi, veliki stolovi, mali stolovi, itd.',
'该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）': 'Ovaj nalog se koristi za prijavu na web sajt kasira (možete pronaći URL web sajta kasira na stranici "Postavke URL-a")',
'该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）': 'Ovaj nalog se koristi za prijavu na web sajt kuhinje (možete pronaći URL web sajta kuhinje na stranici "Postavke URL-a")',
'如无需设置税率可不填写': 'Ako nije potrebno postaviti stopu poreza, možete ostaviti prazno',
'打款信息': 'Informacije o isplati',
'开户行': 'Naziv banke',
'菜品分组': 'Grupisanje jelā',
'自定义名称，仅用于商家自己区分分类，不会展示给顾客': 'Prilagođeno ime, koristi se samo za internu prijavu od strane trgovca i neće biti prikazano kupcima',
'手机网站编辑': 'Uređivanje mobilne web stranice',
'恢复初始默认页面': 'Vrati na početnu stranicu prema zadanim vrednostima',
'通告为手机网站上展示的通知、公告、商家介绍等，“显示”状态时，该篇通告将展示在手机网站上': 'Obaveštenja su informacije, obaveštenja, poslovne prezentacije itd. prikazane na mobilnoj web stranici; kada je u "prikaz" statusu, obaveštenja će biti prikazana na mobilnoj web stranici',
'菜品重量': 'Težina jela',
'请填写菜品重量': 'Molimo unesite težinu jela',
'菜品设置': 'Postavke jela',
'已选择该菜品': 'Odabrali ste ovo jelo',
'添加外卖菜品': 'Dodaj jela za dostavu',
'添加店内菜品': 'Dodaj jela za lokalnu prodaju',
'购买指定菜品成为分销商': 'Kupovinom određenih jela postanite distributer',
'购买指定菜品付款后自动成为分销商，无需后台审核': 'Automatski postanite distributer nakon kupovine određenih jela, bez potrebe za odobrenjem sa servera',
'选择菜品': 'Izaberite jela',
'如开启，分销商自己购买菜品，获得一级佣金': 'Ako je omogućeno, distributeri mogu sami kupiti jela i zaraditi proviziju prvog nivoa',
'订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)”': 'Iznos plaćanja narudžbine (100.00€) * Proporcija nagrađivanja bodova (100%) = Stvarno nagrađeni bodovi (100 bodova)"',
'菜品概况': 'Pregled jela',
'菜品统计': 'Statistika jela',
'在售菜品': 'Jela u ponudi',
'已付款菜品': 'Već plaćena jela',
'菜品总数': 'Ukupan broj jela',
'已上架菜品': 'Jela već na meniju',
'已下架菜品': 'Jela već uklonjena s menija',
'菜品导出': 'Izvezi jelā',
'菜品总销量': 'Ukupna prodaja jela',
'菜品总销售额': 'Ukupan prihod od prodaje jela',
'菜品ID': 'ID jela',
'菜品编码': 'Kod jela',
'菜品收藏数': 'Broj omiljenih jela',
'请至少选择一件产品菜品！': 'Molimo izaberite barem jedno jelo proizvoda!',
"区域管理": "Upravljanje regijāma",
"点餐管理系统": "Sistem upravljanja narudžbinama",
"首页": "Početna stranica",
"在地图中点击确认位置，坐标自动填入":"Kliknite na mapi za potvrdu lokacije, koordinate će biti automatski upisane.",
"添加优惠券请前往'营销工具'—'插件中心'—'优惠券'页面":"Za dodavanje kupona, molimo idite na 'Marketing'-'Marketing Tools'-'Coupon'",
  // ==================== 其它  end    ================
  ...srLocale
}


export default sr



// WEBPACK FOOTER //
// ./src/i18n/langs/sr.js